import { Whisper, Tooltip, IconButton } from 'rsuite'
import { FaCopy } from 'react-icons/fa'
import { Cell } from 'rsuite-table'
import './CopyCell.scss'

const CopyOnHoverCell = ({ rowData, dataKey, ...props }: any) => {
  const value = rowData?.[dataKey] ?? ''

  const shortValue =
    value.length > 16 ? `${value.slice(0, 10)}${value.slice(-4)}` : value

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
  }

  return (
    <Cell {...props}>
      <div className="copy-cell-wrapper">
        <Whisper
          placement="bottom"
          trigger="hover"
          speaker={<Tooltip>{value}</Tooltip>}
        >
          <span className="copy-text">{shortValue}</span>
        </Whisper>

        <Whisper
          placement="bottom"
          trigger="hover"
          speaker={<Tooltip>Copy TaskId</Tooltip>}
        >
          <IconButton
            icon={<FaCopy />}
            size="sm"
            appearance="subtle"
            onClick={handleCopy}
            className="copy-icon"
          />
        </Whisper>
      </div>
    </Cell>
  )
}

export default CopyOnHoverCell
